import { render } from "./PublicationExportOverlay.vue?vue&type=template&id=402f4494"
import script from "./PublicationExportOverlay.vue?vue&type=script&lang=js"
export * from "./PublicationExportOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__